import React from "react";
import Col from '../../common/Col';
import Row from '../../common/Row';
import PropTypes from "prop-types";

const Manual = (props) => {
    const style = {
        zIndex: '1001',
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'white',
        padding: '12px',
        width: '300px',
        boxShadow: '-4px 4px 18px #4d4a4a',
        borderRadius: '5px'
    };

    return (<div style={{ position: 'relative' }} onMouseOut={props.onMouseOut}>
        <div style={style}>
            <Col size={12}>
                Je kan de route uittekenen door met de linkermuisknop punten te plaatsen op de kaart.
                <br />Je kan een punt steeds verleggen/verlengen door met de cursor op dit punt te blijven hangen zodat er een wijsvinger verschijnt.
                <br />Maak je de route langer, dan zal je zien dat er extra punten verschijnen. Deze kan je weer opnieuw verleggen en/of verlengen. Zo kan je steeds je route aanpassen.
                <br />Je kan een punt verwijderen met je rechtermuisknop.
            </Col>
        </div>
        <div className="background"/>
    </div>);
};

Manual.propTypes = {
    onMouseOut: PropTypes.func
};

export default Manual;